var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.58325 15.5C2.58325 8.36632 8.36624 2.58333 15.4999 2.58333C22.6335 2.58333 28.4166 8.36632 28.4166 15.5C28.4166 22.6336 22.6335 28.4167 15.4999 28.4167C8.36624 28.4167 2.58325 22.6336 2.58325 15.5ZM15.2783 8.72826C15.9917 8.72826 16.5699 9.30655 16.5699 10.0199V16.4358L21.1255 18.1677C21.7924 18.4211 22.1275 19.1672 21.8739 19.8339C21.6205 20.5008 20.8744 20.8359 20.2077 20.5823L14.8193 18.5341C14.318 18.3435 13.9866 17.863 13.9866 17.3267V10.0199C13.9866 9.30655 14.5649 8.72826 15.2783 8.72826Z",
    fill: "#52447D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime1);
export default __webpack_public_path__ + "static/media/time1.06a875dd33ca80b834fa461a95378139.svg";
export { ForwardRef as ReactComponent };